"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProjectableReaderObjectConverter_1 = require("../../core/conversions/ProjectableReaderObjectConverter");
/**
 * WindowItemForecastConverter.
 *
 * @author Stepan Mik
 */


var WindowItemForecastConverter =
/*#__PURE__*/
function (_ProjectableReaderObj) {
  _inherits(WindowItemForecastConverter, _ProjectableReaderObj);

  function WindowItemForecastConverter() {
    _classCallCheck(this, WindowItemForecastConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastConverter).apply(this, arguments));
  }

  return WindowItemForecastConverter;
}(ProjectableReaderObjectConverter_1.ProjectableReaderObjectConverter);

exports.WindowItemForecastConverter = WindowItemForecastConverter;